import { selectHasSynchronizationStatusCatalogFeature } from 'modules/feature-flag/selectors';

export const synchronizationStatusFilter = {
  key: 'alkemics.synchronizationStatus',
  query: 'synchronizationStatus',
  isAvailable: ({ user } = {}) =>
    selectHasSynchronizationStatusCatalogFeature(user),
};
